module.exports = __webpack_public_path__ + "img/header-memoireRingsGrowingMemoires@2x.f758483.jpg";